import { i18n } from '@lingui/core'
import { linguiLocales, linguiDefaultLocale, phones } from '../../locales'
import { LocalStorage } from './localStorage'

// const deviceLocale = getDeviceLocale(linguiLocales, linguiDefaultLocale)
// const initialLocale = getSimilarLocale(deviceLocale, linguiDefaultLocale, linguiLocales)

const persistedLocale = LocalStorage.getItem('LOCALE')

const appLocale = persistedLocale ?? linguiDefaultLocale

function loadI8n() {
  i18n.load(linguiLocales)
  i18n.activate(appLocale)
}

loadI8n()

function setI18nLocale(newLocale: string) {
  i18n.activate(newLocale)
  LocalStorage.setItem('LOCALE', newLocale)
}

function getCurrentI18nLocale() {
  return appLocale
}

export {
  setI18nLocale,
  getCurrentI18nLocale,
  appLocale,
  phones,
  loadI8n,
}